import React from "react";
import PropTypes from 'prop-types';
import cn from 'classnames';

// import commoncss from '~/themes/common.css';

import Tooltip from "~/ui/Tooltip/Tooltip";

import { connect } from '~/redux/connect';
import { presentColumns, deriveNewListOrder } from "~/statePresenter";
import { getCalendar, getModelTooltip, getPresentColumnsData, getTooltipsActive } from "~/stateGetter";
import css from './tableSettings.css';
import { settingsActionCreator } from "../../actions/settingsActions";
import debounce from 'lodash/debounce';
import { Box, IconMenu, MenuDivider, MenuGroup, MenuItem } from "~/native-ui"
import { HighLightText, SpinnerInput } from "../../native-ui";
import { Sortable } from "~/native-ui/sortable/Sortable";

class TableSettings extends React.Component {
	static propTypes = {
        tooltipsActive: PropTypes.bool.isRequired,
        tableSettingsTooltip: PropTypes.string.isRequired,
        changeColumnVisibility: PropTypes.func.isRequired,
        columns: PropTypes.array.isRequired,
        isCalendarEnabled: PropTypes.bool.isRequired,
	};

    notUniqueTextValue = String(new Date().getTime());
    shouldSetFocus = false;

    state = {
        searchTerm: "",
    }

    searchInputRef = React.createRef(null);

    
    resetColumns = () => {
        this.props.resetColumns();
    }
    
    onReorder = (oldIndex, newIndex) => {
        this.props.onColumnReorder({
            ...this.props.columnOrder,
            ...this.props.deriveNewListOrder(this.props.columns, oldIndex, newIndex)
        })
    }

    getCaption(column) {
        let { hidden, name, title } = column;
        return ( title )
    }

    handleOpen = () => {
        this.shouldSetFocus = true;
    }


    renderResetButton () {
        return (
            <Box
                bottom="0"
                position="sticky"
                backgroundColor="#fff"
            >
                <MenuDivider />
                <MenuItem
                    key={"reset-columns"}
                    textValue={this.notUniqueTextValue}
                    caption={this.props.trans("reset_columns")}
                    onClick={this.resetColumns}
                    orderable={false}
                />
            </Box>
        )
    }

    setSearchTerm = (searchTerm, event) => {
        event?.preventDefault();
        event?.stopPropagation();
        this.setState({ searchTerm })
    }

    setSearchRef = (ref) => {
        this.searchInputRef.current = ref;
        if (this.shouldSetFocus) {
            this.shouldSetFocus = false;
            setTimeout(() => { ref?.focus?.(); })
        }
    }
    

    renderSearch () {
        return (
            <MenuItem
                pt="0"
                bottom="0"
                position="sticky"
                backgroundColor="#fff"
                orderable={false}
                textValue={this.notUniqueTextValue}
            >
                <SpinnerInput 
                    placeholder={this.props.trans('search')}
                    value={this.state.searchTerm}
                    // className={css.search}
                    onChange={this.setSearchTerm}
                    ref={this.setSearchRef}
                />
            </MenuItem>
        )
    }

    menuProps = {
        closeOnSelect: false,
        canReorder: true,
        onReorder: this.onReorder,
        orderable: true,
        shouldOverlapWithTrigger: true,
        onKeyDown: this.setSearchTerm,
    }

    render() {
        let { columns, changeColumnVisibility, isCalendarEnabled } = this.props;

        if (isCalendarEnabled) {
            return null;
        }

        const regex = this.state.searchTerm ? new RegExp(this.state.searchTerm, "ig") : null

        const renderColumnItem = (renderedColumns, column, i) => {
            let { hidden, name, title } = column;

            if(title.length < 1) {
                return renderedColumns;
            }

            if(regex && !regex.test(title)) {
                return renderedColumns;
            }

            const onClick = debounce(() => { changeColumnVisibility(name) }, { leading: true })
            renderedColumns.push(<MenuItem
                key={name}
                checkable
                orderable
                index={i}
                textValue={this.notUniqueTextValue}
                value={column.name}
                caption={<HighLightText key={name+"caption"} value={this.getCaption(column)} searchTerm={this.state.searchTerm} />}
                className={cn({["uncheckedMenuItem"]: hidden})}
                onClick={onClick}
            />);

            return renderedColumns;
        };

        const visibleColumns = columns.reduce((visibleColumns, { hidden, name }) => hidden ? visibleColumns : visibleColumns.concat(name), []),
              hiddenColumnsCount = columns.length - visibleColumns.length,
              label = hiddenColumnsCount ? this.props.trans('columns_configuration.hiddenColumnsCount', { count: hiddenColumnsCount }) : this.props.trans('columns_configuration.hideColumns'),
              buttonProps = {
                ml: "2",
                primary: true,
                iconSize: "sm",
                position: "relative",
                // badge: undefined hiddenColumnsCount,
                variant: hiddenColumnsCount ? "ghost_faded" : undefined,
                ...this.props.buttonProps
            }

        return (
            <React.Fragment>
                <IconMenu icon="table-headers-eye-off" tooltip={label} iconFamily="material-community" buttonProps={buttonProps} menuProps={ this.menuProps } onOpen={this.handleOpen}>
                    {this.renderSearch()}
                    <MenuGroup value={ visibleColumns } checkbox>
                        {columns.reduce(renderColumnItem, [])}
                    </MenuGroup>
                    {this.renderResetButton()}
                </IconMenu>
                <Tooltip className={css.tableSettingsTooltip} tooltip={this.props.tableSettingsTooltip} />
            </React.Fragment>
        )
    };
}

export default connect(
    (state, {modelId}) => ({
        tooltipsActive: getTooltipsActive(state),
        tableSettingsTooltip: getModelTooltip(state, modelId, 'table_settings'),
        isCalendarEnabled: getCalendar(state, modelId).isCalendarEnabled,
        ...getPresentColumnsData(state, modelId),
    }),
    (dispatch, {modelId}) => {
        let settingActions = settingsActionCreator(modelId);

        return {
            changeColumnVisibility: (name) => dispatch(settingActions.toggleColumnVisibility(name)),
            onColumnReorder: (columnOrder) => dispatch(settingActions.changeColumnOrder(columnOrder)),
            resetColumns: () => dispatch(settingActions.resetColumns())
        }
    },
    (props, dispatchProps, ownProps) => ({
        ...ownProps,
        ...dispatchProps,
        ...props,
        deriveNewListOrder,
        columns: presentColumns(props),
    })
)(TableSettings)